import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const convertToDataTable = (data: IGetLineType[]): IGetLineType[] => {
  const dataTableData: IGetLineType[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllLineTypesList = async (): Promise<IGetLineType[]> => {
  const response =  await axiosDefaultApi.get(`/api/LineTypes/GetLineTypes`);
  return convertToDataTable(response as unknown as IGetLineType[]);
};

type QueryFnType = typeof getAllLineTypesList;

type UseGetAllLineTypesListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllLineTypesList = ({ config }: UseGetAllLineTypesListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllLineTypes'],
    queryFn: () => getAllLineTypesList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};